import { Record, Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { class_type, record_type, union_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { toText, replace, substring, endsWith, printf, toFail } from "./fable_modules/fable-library.3.7.20/String.js";
import { replace as replace_1, create, match } from "./fable_modules/fable-library.3.7.20/RegExp.js";
import { Result_Map, FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";
import { Http_request, Http_method, Http_withCredentials, Http_send, Http_header } from "./fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, Header } from "./fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { parseDateOnly, DateOnlyExtensions_yyyy_MM_dd, getCookie } from "./Utils.js";
import { singleton } from "./fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { uint64 as uint64_1, Auto_generateBoxedDecoder_79988AEF, fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Lazy, uncurry } from "./fable_modules/fable-library.3.7.20/Util.js";
import { ExtraCoders, ErrorReason, CaseStrategy } from "./fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { DateModule_toStr, DateFormat_get_yyyy$002DMM$002Ddd, DateModule_parse } from "./Svea.Dry/Time.js";
import { UTCModule_toIso8601Z, UTCModule_Parse_iso8601Z } from "./fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { toNumber } from "./fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "./fable_modules/fable-library.3.7.20/Decimal.js";
import { orElseWith } from "./fable_modules/fable-library.3.7.20/Option.js";
import { Parse_Decimal } from "./fable_modules/Svea.Dry.Fable.1.0.4/More.fs.js";
import { newGuid } from "./fable_modules/fable-library.3.7.20/Guid.js";
import { add } from "./fable_modules/fable-library.3.7.20/Map.js";
import { toNumber as toNumber_1 } from "./fable_modules/fable-library.3.7.20/Long.js";
import { int64 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { empty } from "./fable_modules/Thoth.Json.10.2.0/Extra.fs.js";
import { uint64 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export function getApplicationReloadUrl() {
    return window.location.origin + window.location.pathname;
}

export const baseUrl = window.location.origin + window.location.pathname;

export class UrlKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["RelativeFenixWeb", "RelativeFenixApi", "AbsoluteUrl", "RelativeFenixWebFileUrl"];
    }
}

export function UrlKind$reflection() {
    return union_type("HttpV2.UrlKind", [], UrlKind, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export function FenixApi_getUseApiProxy() {
    let origin;
    try {
        origin = window.location.origin;
    }
    catch (matchValue) {
        origin = "";
    }
    if (origin.indexOf("localhost:") >= 0) {
        return true;
    }
    else {
        return false;
    }
}

export function FenixApi_getApiBaseUrl() {
    const localhostStr = "localhost:";
    let origin;
    try {
        origin = window.location.origin;
    }
    catch (matchValue) {
        origin = localhostStr;
    }
    if (origin.indexOf(localhostStr) >= 0) {
        return "https://fenixapi.dev.svea.com/";
    }
    else if (origin.indexOf("fenixweb.dev.svea.com") >= 0) {
        return "https://fenixapi.dev.svea.com/";
    }
    else if (origin.indexOf("fenixweb.test.svea.com") >= 0) {
        return "https://fenixapi.test.svea.com/";
    }
    else if (origin.indexOf("fenixweb.uat.svea.com") >= 0) {
        return "https://fenixapi.uat.svea.com/";
    }
    else if (origin.indexOf("fenixwebstage.svea.com") >= 0) {
        return "https://fenixapistage.svea.com/";
    }
    else if (origin.indexOf("fenixwebdemo.svea.com") >= 0) {
        return "https://fenixapidemo.svea.com/";
    }
    else if (origin.indexOf("fenixweb.svea.com") >= 0) {
        return "https://fenixapi.svea.com/";
    }
    else {
        return toFail(printf("Unable to determine Fenix API Url with origin: %s"))(origin);
    }
}

export class ValidatedUrl extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ValidatedUrl"];
    }
}

export function ValidatedUrl$reflection() {
    return union_type("HttpV2.ValidatedUrl", [], ValidatedUrl, () => [[["Item", string_type]]]);
}

export function ValidatedUrl__get_Value(this$) {
    return this$.fields[0];
}

const ValidatedUrlModule_urlRegexPattern = "^(https?)://[^\\s/$.?#^].[^\\s]*$";

export function ValidatedUrlModule_removeTrailingSlash(str) {
    if (endsWith(str, "/")) {
        return substring(str, 0, str.length - 1);
    }
    else {
        return str;
    }
}

export function ValidatedUrlModule_ensureTrailingSlash(str) {
    if (endsWith(str, "/")) {
        return str;
    }
    else if (str.indexOf("?") >= 0) {
        return str;
    }
    else {
        return str + "/";
    }
}

function ValidatedUrlModule_ensureTrailingSlashBeforeQueryString(str) {
    const matchValue = str.lastIndexOf("?") | 0;
    if (matchValue === -1) {
        return str;
    }
    else {
        const questionMarkPosition = matchValue | 0;
        if (str[questionMarkPosition - 1] === "/") {
            return str;
        }
        else {
            return (substring(str, 0, questionMarkPosition) + "/") + substring(str, questionMarkPosition);
        }
    }
}

function ValidatedUrlModule_removeInitialSlash(str) {
    if (str.indexOf("/") === 0) {
        return substring(str, 1);
    }
    else {
        return str;
    }
}

function ValidatedUrlModule_removeDoubleSlashes(str) {
    return replace(str, "//", "/");
}

function ValidatedUrlModule_replaceWhitespace(str) {
    return replace(str, " ", "%20");
}

function ValidatedUrlModule_matchesUrlPattern(baseUrl_1, relativeUrl) {
    const completeUrl = (baseUrl_1 != null) ? (ValidatedUrlModule_ensureTrailingSlash(baseUrl_1) + ValidatedUrlModule_replaceWhitespace(ValidatedUrlModule_removeInitialSlash(ValidatedUrlModule_ensureTrailingSlashBeforeQueryString(ValidatedUrlModule_ensureTrailingSlash(ValidatedUrlModule_removeDoubleSlashes(relativeUrl)))))) : ValidatedUrlModule_replaceWhitespace(ValidatedUrlModule_ensureTrailingSlashBeforeQueryString(ValidatedUrlModule_ensureTrailingSlash(relativeUrl)));
    let regexMatch;
    const tupledArg = [completeUrl, ValidatedUrlModule_urlRegexPattern];
    regexMatch = match(create(tupledArg[1]), tupledArg[0]);
    if (regexMatch != null) {
        return new FSharpResult$2(0, new ValidatedUrl(0, regexMatch[0]));
    }
    else {
        return new FSharpResult$2(1, toText(printf("Not a valid URL: \"%s\"."))(completeUrl));
    }
}

export function ValidatedUrlModule_create(url) {
    switch (url.tag) {
        case 0: {
            return ValidatedUrlModule_matchesUrlPattern(baseUrl, url.fields[0]);
        }
        case 1: {
            const relativeUrl_1 = url.fields[0];
            if (FenixApi_getUseApiProxy()) {
                return ValidatedUrlModule_matchesUrlPattern(baseUrl, "API/" + ValidatedUrlModule_removeInitialSlash(relativeUrl_1));
            }
            else {
                return ValidatedUrlModule_matchesUrlPattern(FenixApi_getApiBaseUrl(), relativeUrl_1);
            }
        }
        case 3: {
            return Result_Map((url_1) => (new ValidatedUrl(0, ValidatedUrlModule_removeTrailingSlash(ValidatedUrl__get_Value(url_1)))), ValidatedUrlModule_matchesUrlPattern(baseUrl, url.fields[0]));
        }
        default: {
            return ValidatedUrlModule_matchesUrlPattern(void 0, url.fields[0]);
        }
    }
}

export function ValidatedUrlModule_value(_arg) {
    return _arg.fields[0];
}

export const addClientReference = (req) => Http_header(new Header(0, "client-reference", "FenixWeb-Fable"), req);

export class CsrfTokenDTO extends Record {
    constructor(csrfToken) {
        super();
        this.csrfToken = csrfToken;
    }
}

export function CsrfTokenDTO$reflection() {
    return record_type("HttpV2.CsrfTokenDTO", [], CsrfTokenDTO, () => [["csrfToken", string_type]]);
}

export function getCSRFTokenAndSetCookie() {
    const matchValue = getCookie("ClientCSRFToken");
    if (matchValue == null) {
        const matchValue_1 = ValidatedUrlModule_create(new UrlKind(0, "/auth/csrf-token/"));
        if (matchValue_1.tag === 1) {
            return singleton.Return(new FSharpResult$2(1, matchValue_1.fields[0]));
        }
        else {
            return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue_1.fields[0])))))), (_arg) => {
                const response = _arg;
                const result = (response.statusCode === 200) ? fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(CsrfTokenDTO$reflection(), new CaseStrategy(1), void 0)), response.responseText) : (new FSharpResult$2(1, toText(printf("[getCSRFCookie] status code \u003c\u003e 200, responseText: %s"))(response.responseText)));
                return singleton.Return(result);
            }));
        }
    }
    else {
        const x = new FSharpResult$2(0, new CsrfTokenDTO(matchValue));
        return singleton.Return(x);
    }
}

export function addCsrfHeader(csrfToken, request) {
    return Http_header(new Header(0, "X-CSRF-Token", csrfToken), request);
}

export function getCsrfEnabledRequest(request) {
    const fenixApiUrl = FenixApi_getApiBaseUrl();
    if (request.url.indexOf(fenixApiUrl) >= 0) {
        return singleton.Return(request);
    }
    else {
        return singleton.Delay(() => singleton.Bind(getCSRFTokenAndSetCookie(), (_arg) => {
            const csrfTokenDTOResult = _arg;
            return singleton.Return((csrfTokenDTOResult.tag === 1) ? (() => {
                throw (new Error(csrfTokenDTOResult.fields[0]));
            })() : addCsrfHeader(csrfTokenDTOResult.fields[0].csrfToken, request));
        }));
    }
}

function CustomExtra_ensureThreeMilliseconds(timestamp) {
    return replace_1(timestamp, "\\.?(\\d{1,3})?Z$", (m) => {
        const matchValue = m[1] || "";
        return (matchValue === "") ? ".000Z" : ((matchValue.length === 1) ? (("." + matchValue) + "00Z") : ((matchValue.length === 2) ? (("." + matchValue) + "0Z") : ((matchValue.length === 3) ? (("." + matchValue) + "Z") : m[0])));
    });
}

function CustomExtra_dateDecode(path, value) {
    if ((typeof value) === "string") {
        const value_1 = value;
        const matchValue = DateModule_parse(DateFormat_get_yyyy$002DMM$002Ddd(), value_1);
        if (matchValue == null) {
            return new FSharpResult$2(1, [path, new ErrorReason(2, "yyyy-MM-dd string", value_1)]);
        }
        else {
            return new FSharpResult$2(0, matchValue);
        }
    }
    else {
        return new FSharpResult$2(1, [path, new ErrorReason(0, "yyyy-MM-dd string", value)]);
    }
}

const CustomExtra_dateEncode = (() => {
    let f1;
    const format = DateFormat_get_yyyy$002DMM$002Ddd();
    f1 = ((d) => DateModule_toStr(format, d));
    return f1;
})();

const CustomExtra_dateOnlyEncode = DateOnlyExtensions_yyyy_MM_dd;

function CustomExtra_dateOnlyDecode(path, value) {
    if ((typeof value) === "string") {
        const value_1 = value;
        const matchValue = parseDateOnly(value_1);
        if (matchValue == null) {
            return new FSharpResult$2(1, [path, new ErrorReason(2, "yyyy-MM-dd string", value_1)]);
        }
        else {
            return new FSharpResult$2(0, matchValue);
        }
    }
    else {
        return new FSharpResult$2(1, [path, new ErrorReason(0, "yyyy-MM-dd string", value)]);
    }
}

function CustomExtra_utcDecode(path, value) {
    if ((typeof value) === "string") {
        const value_1 = value;
        const matchValue = UTCModule_Parse_iso8601Z(value_1);
        if (matchValue == null) {
            return new FSharpResult$2(1, [path, new ErrorReason(2, "yyyy-MM-ddTHH:mm:ss.fffZ string", value_1)]);
        }
        else {
            return new FSharpResult$2(0, matchValue);
        }
    }
    else {
        return new FSharpResult$2(1, [path, new ErrorReason(0, "yyyy-MM-ddTHH:mm:ss.fffZ string", value)]);
    }
}

function CustomExtra_decimalDecode(path, value) {
    if ((typeof value) === "number") {
        return new FSharpResult$2(0, new Decimal(value));
    }
    else if ((typeof value) === "string") {
        const matchValue = orElseWith(Parse_Decimal(2, value), () => Parse_Decimal(1, value));
        if (matchValue == null) {
            return new FSharpResult$2(1, [path, new ErrorReason(0, "a decimal", value)]);
        }
        else {
            return new FSharpResult$2(0, matchValue);
        }
    }
    else {
        return new FSharpResult$2(1, [path, new ErrorReason(0, "a decimal", value)]);
    }
}

const CustomExtra_utcEncode = (arg_1) => CustomExtra_ensureThreeMilliseconds(UTCModule_toIso8601Z(arg_1));

function CustomExtra_withUTC(x) {
    let copyOfStruct;
    return new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("Svea.Dry.Time.UTC", [CustomExtra_utcEncode, (path) => ((value) => CustomExtra_utcDecode(path, value))], x.Coders));
}

function CustomExtra_withDate(x) {
    let copyOfStruct;
    return new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.DateOnly", [CustomExtra_dateEncode, (path) => ((value) => CustomExtra_dateDecode(path, value))], x.Coders));
}

function CustomExtra_withDateOnly(x) {
    let copyOfStruct;
    return new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.DateOnly", [CustomExtra_dateOnlyEncode, (path) => ((value) => CustomExtra_dateOnlyDecode(path, value))], x.Coders));
}

function CustomExtra_withDecimal(x) {
    let copyOfStruct;
    return new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.Decimal", [toNumber, (path) => ((value_1) => CustomExtra_decimalDecode(path, value_1))], x.Coders));
}

export class Http {
    constructor() {
    }
}

export function Http$reflection() {
    return class_type("HttpV2.Http", void 0, Http);
}

export function Http_get_ExtraCoders() {
    return new Lazy(() => {
        let extra_3, copyOfStruct, copyOfStruct_1;
        return CustomExtra_withUTC(CustomExtra_withDateOnly(CustomExtra_withDate((extra_3 = CustomExtra_withDecimal(new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.Int64", [toNumber_1, int64], empty.Coders))), new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("System.UInt64", [uint64, uint64_1], extra_3.Coders))))));
    });
}

